import gql from "graphql-tag";

export const MY_HR_CHANGE_REQUESTS_SUBSCRIPTION = gql`
  subscription changeRequestsSubscription {
    changeRequestsSubscription
  }
`;
